import React from "react";
import { useTranslation } from "react-i18next";
import { styled } from "goober";
import { mobile } from "clutch/src/Style/style.mjs";

import IOSClose from "@/inline-assets/ios-close.svg";
import Divider from "@/shared/Divider.jsx";

const MobileDropdownCover = styled("div")`
  display: none;

  ${mobile} {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    inset: 0;
    height: 100dvh;
    height: 100vh;
    background: var(--shade10-75);
    z-index: 4;
    padding: var(--sp-4);

    .wrapper {
      min-height: calc(var(--sp-1) * 40);
      max-height: 100%;
      overflow: auto;
      width: 100%;
      border-radius: var(--sp-5);
      border: 1px solid var(--shade3-15);
      background: var(--shade7);

      > div.dropdown-row {
        display: flex;
        padding: var(--sp-3) var(--sp-6);
        align-items: center;
        gap: var(--sp-2);
        align-self: stretch;

        > span {
          flex: 1 0 0;
          color: var(--shade0);
        }
      }
    }
  }
`;

const DropdownTitle = styled("div")`
  position: relative;
  width: 100%;

  .title {
    display: flex;
    width: 21.4375rem;
    padding: var(--sp-5) 3.75rem var(--sp-4) var(--sp-6);
    align-items: flex-start;
    gap: var(--sp-2);
    align-self: stretch;
    background: var(--shade8);

    > span {
      color: var(--shade0);
      flex: 1 0 0;
    }
  }

  .close {
    display: flex;
    padding: var(--sp-2);
    justify-content: center;
    align-items: center;
    gap: var(--sp-2);
    position: absolute;
    right: var(--sp-3);
    top: var(--sp-3);

    > div.close-button {
      display: flex;
      padding: var(--sp-1);
      flex-direction: column;
      align-items: center;
      border-radius: var(--sp-6);
      background: var(--shade6-50);
    }

    svg {
      width: var(--sp-4_5);
      height: var(--sp-4_5);
    }
  }
`;

export default function MobileDropdown({
  title,
  titleComponent,
  className,
  children,
}: {
  title?: Translation;
  titleComponent?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}) {
  const { t } = useTranslation();

  return (
    <MobileDropdownCover className={className}>
      <div className="wrapper">
        <DropdownTitle>
          <div className="title">
            {titleComponent ? (
              titleComponent
            ) : title ? (
              <span className="type-large--title">{t(...title)}</span>
            ) : null}
          </div>
          <div className="close">
            <div className="close-button">
              <IOSClose />
            </div>
          </div>
        </DropdownTitle>
        <Divider />
        {children}
        <Divider />
      </div>
    </MobileDropdownCover>
  );
}
